var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section"},[(_vm.title && _vm.title.length > 0)?_c('div',{staticClass:"section-header"},[_c('div',{staticClass:"section-mark",style:({ 'border-left-color': _vm.mColor })}),_c('div',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.title))]),_vm._t("header")],2):_vm._e(),_c('div',{staticClass:"content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }